var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"urlButtonContainer"},[_c('div',{staticClass:"urlButtonDiv"},[_c('el-button',{staticClass:"urlButton",attrs:{"type":"primary"},on:{"click":_vm.goTo}},[_vm._v(_vm._s(_vm.name))])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }